import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import sx from './styles'

const Easyhowworks = ({ items }) => {
  return (
    <Grid
      container
      display="flex"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
      size={12}
      mt={10}
      mb={15}
      gap={2}
      p={1}
      sx={sx.gridElements}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        mt={3}
        maxWidth="1063px"
      >
        {items
          && items
            .filter((i) => (i?.id !== 2 && i?.id !== 4))
            .map((item, index) => (
              <Grid
                key={`item-qw-${index}`}
                size={{
                  xs: 12,
                  sm: 3,
                }}
              >
                <Typography
                  component="h4"
                  sx={sx.listTextTitles}
                  variant="h3"
                >
                  <FormattedMessage id={item.title} />
                </Typography>

                <Typography
                  variant="body1"
                >
                  <FormattedMessage id={item.description} />
                </Typography>
              </Grid>
            ))}

      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        mt={3}
        maxWidth="1063px"
      >

        {items && items
          .filter((i) => (i?.id !== 1 && i?.id !== 3))
          .map((item, index) => (
            <Grid
              key={`item-alksjn-${index}`}
              size={{
                xs: 12,
                sm: 3,
              }}
            >
              <Typography
                component="h4"
                sx={sx.listTextTitles}
                variant="h3"
              >
                <FormattedMessage id={item.title} />
              </Typography>

              <Typography
                variant="body1"
              >
                <FormattedMessage id={item.description} />
              </Typography>
            </Grid>
          ))}

      </Box>
    </Grid>
  )
}

export default memo(Easyhowworks)
